import PropTypes from 'prop-types';

export default function Screen1({ onNext, onPremise, ePremise }) {
  return (
    <>
      <div id='bf-chat-window-screen-1' className='screen'>
        <div className='wrapper'>
          <div className='row'>
            <div className='col'>
              <h2 className='title'>Where would you like to buy?</h2>
              <div className='buttons'>
                {ePremise === true && (
                  <button
                    id='bf-chat-window-body-purchase-online'
                    className='btn btn-primary'
                    onClick={() => onNext('purchaseOnline')}
                  >
                    Purchase Online
                  </button>
                )}

                {onPremise === true && (
                  <button
                    id='bf-chat-window-body-find-near-you'
                    className='btn btn-primary'
                    onClick={() => onNext('', '', 'findNearYou')}
                  >
                    Purchase In-store
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Screen1.propTypes = {
  onNext: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onPremise: PropTypes.bool.isRequired,
  ePremise: PropTypes.bool.isRequired,
};
